<div class="tab-container">
    <div class="tab-header">
      <button
        class="tab-button"
        [class.active]="activeTab === 'organization'"
        (click)="selectTab('organization')"
      >
       Organization
      </button>

      <button *ngIf="['Admin', 'Superuser', 'Member'].includes(role)"
        class="tab-button"
        [class.active]="activeTab === 'staff'"
        (click)="selectTab('staff')"
      >
        Staff
      </button>
      <button *ngIf="['Admin', 'Member'].includes(role)"
        class="tab-button"
        [class.active]="activeTab === 'camera'"
        (click)="selectTab('camera')"
      >
        Camera
      </button>

        <button *ngIf="canViewOrganizationsTab()"
        class="tab-button"
        [class.active]="activeTab === 'customer'"
        (click)="selectTab('customer')"
      >
        Organizations
      </button>
      
    </div>
    <div class="tab-content">
      <div *ngIf="activeTab === 'organization'" class="tab-panel">
        <div class="actions">
          <button class="btn-action"  (click)="toggleEdit()" [disabled]="role === 'Member'" [title]="role === 'Member' ? 'You are not authorized to perform this action.': 'Edit Organization'">
            <fa-icon [icon]="['fas', 'pen']"></fa-icon>
            Edit</button>
        </div>
          <div class="org-container">
            <div class="org-content">
              <div class="org-info">
                <div class="org-header">
                  <h2>Organization Info</h2>
                </div>
                
                <div class="info-grid">
                  <div class="info-item">
                    <label>Name</label>
                    <span class="info-value">{{organizationDetail.name}}</span>
                  </div>
                  
                  <div class="info-item">
                    <label>Address</label>
                    <span class="info-value">
                      {{organizationDetail.address.full_address}}
                     
                    </span>
                  </div>
                  
                  <div class="info-item">
                    <label>Created Date</label>
                    <span class="info-value">{{organizationDetail.created_at | date: 'dd/MM/yyyy'}}</span>
                  </div>
                    <div class="info-item" *ngIf="isPlatformSuperuser && organizationDetail.customer_source_label">
                    <label>Customer Source</label>
                    <span class="info-value">{{organizationDetail.customer_source_label}}</span>
                  </div>
                    <div class="info-item"
                         *ngIf="isPlatformSuperuser && organizationDetail.source_sales_installation_partner_name">
                    <label>Source Partner</label>
                    <span class="info-value">{{organizationDetail.source_sales_installation_partner_name}}</span>
                  </div>
                    <div class="info-item" *ngIf="isPlatformSuperuser && organizationDetail.installation_by_label">
                    <label>Installation By</label>
                    <span class="info-value">{{organizationDetail.installation_by_label}}</span>
                  </div>
                    <div class="info-item"
                         *ngIf="isPlatformSuperuser && organizationDetail.installation_sales_installation_partner_name">
                    <label>Installation Partner</label>
                    <span class="info-value">{{organizationDetail.installation_sales_installation_partner_name}}</span>
                  </div>
                </div>
              </div>
              
              <div class="org-image">
                  <input
                    #fileInput
                    type="file"
                    (change)="onFileSelected($event)"
                    accept="image/jpeg,image/png,image/jpg,image/webp"
                    style="display: none;" />
                  <app-organization-avatar
                          [name]="organizationDetail.name"
                          [imageUrl]="organizationDetail.profile_pic_url"
                          cssClass="profile-img"
                          (refreshRequested)="refreshOrganizationProfileImage()"
                  ></app-organization-avatar>
                  <div class="camera-overlay" (click)="fileInput.click()">
                    <fa-icon [icon]="['fas', 'camera']"></fa-icon>
                  </div>
                  <button
                          type="button"
                          class="btn-remove-image"
                          *ngIf="organizationDetail.profile_pic_url"
                          (click)="deleteProfileImage()"
                          title="Remove profile image">
                      <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                  </button>
              </div>
            </div>
          </div>

          <app-organization-onboarding [organizationId]="orgId"></app-organization-onboarding>
      </div>
      <div *ngIf="activeTab === 'staff'" class="tab-panel">
        <div>
            <div class="actions">
              <button class="btn-action" (click)="addStaff()" [disabled]="role === 'Member'" [title]="role === 'Member' ? 'You are not authorized to perform this action.': 'Add staff'">
                <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
                Add Staff</button>
                <button *ngIf="isPlatformSuperuser" class="btn-action" (click)="addDemoStaff()">
                    <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
                    Add Demo Account
                </button>
            </div>
            <div class="container-table">
              <div>
                <div class="tab-head">
                  <div class="search-bar">
                    <!-- <div>
                      <form  (ngSubmit)="UserSearch()">
                        <input type="text" [(ngModel)]="searchText" name='searchText' id="searchText" placeholder="Search">
                        <button type="submit" style="width: 40px; height: 40px; border-radius: 50%; border: none; background: rgb(37, 139, 229); cursor: pointer;" hidden>
                          <fa-icon [icon]="['fas', 'magnifying-glass']" class="fa-thin" style="color: rgb(228, 235, 237);font-size: 20px;"></fa-icon>
                        </button>
                      </form>
                    </div> -->
                    <app-generic-search
                      [apiUrl]="'users/search_suggestion'"
                      [resultsApiUrl]="'users/'"
                      [method]="'GET'"
                      [searchParamName]="'q'"
                      [extraBody]="{ is_staff_page: true, org_id: staffOrganizationId || '' }"
                      [pageSize]="10"
                      [minChars]="2"
                      (resultsFetched)="onUserResults($event)">
                    </app-generic-search>
                  </div>
                    <div *ngIf="isPlatformSuperuser" class="staff-org-filter">
                    <label for="staffOrgFilter"><strong>Organization</strong></label>
                    <select id="staffOrgFilter" [(ngModel)]="staffOrganizationId" (change)="onStaffOrganizationChange()">
                      <option value="">All</option>
                      <option *ngFor="let org of staffOrganizations" [value]="org.id">{{ org.name }}</option>
                    </select>
                  </div>
                  <button (click)="staffExportToExcel()" class="export-button">
                    <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
                    EXPORT EXCEL
                  </button>
                </div>
                <div class="responsive-table-wrapper">
                  <table>
                    <thead>
                        <tr>
                        <th>S.No</th>
                        <!-- <th>User Name</th> -->
                        <th>Username</th>
                        <!-- <th>Last Name</th> -->
                        <th>Email</th>
                        <th>Organization</th>
                        <th>Phone Number</th>
                        <th>Role</th>
                            <th>Status</th>
                        <th>Action Items</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let record of userDetail let i = index ">
                          <td>{{ i + 1 + (staffCurrentPage - 1) * staffRecordsPerPage }}</td>
                          <!-- <td>{{ record.first_name }}</td>
                          <td>{{ record.last_name }}</td> -->
                          <td>{{ record.username}}</td>
                          <td>{{ record.email }}</td>
                          <td>{{ record.organization }}</td>
                          <td>{{record.mobile_number}}</td>
                            <td>
                                <div class="staff-role-cell">
                                    <span>{{record.groups[0]}}</span>
                                    <span class="demo-user-badge" *ngIf="record.is_demo_user">Demo User</span>
                                    <span class="demo-expiry-badge"
                                          *ngIf="record.is_demo_user && record.demo_days_remaining !== null">
                                Expires in {{ record.demo_days_remaining }} days
                              </span>
                                </div>
                            </td>
                            <td>
                                <div class="subscription-toggle" *ngIf="isPlatformSuperuser; else staffStatusReadonly">
                                    <label class="toggle-switch"
                                           [title]="record.is_active ? 'Disable staff account' : 'Enable staff account'">
                                        <input
                                                type="checkbox"
                                                [checked]="record.is_active !== false"
                                                [disabled]="!canToggleStaffStatus(record) || record.staff_status_loading"
                                                (click)="openStaffStatusDialog(record, !record.is_active, $event)"/>
                                        <span class="toggle-slider"></span>
                                    </label>
                                    <span class="status-pill" [class.active]="record.is_active !== false"
                                          [class.inactive]="record.is_active === false">
                                {{ record.is_active === false ? 'Disabled' : 'Active' }}
                              </span>
                                </div>
                                <ng-template #staffStatusReadonly>
                              <span class="status-pill" [class.active]="record.is_active !== false"
                                    [class.inactive]="record.is_active === false">
                                {{ record.is_active === false ? 'Disabled' : 'Active' }}
                              </span>
                                </ng-template>
                            </td>
                          <td class="table-actions-cell">
                            <div class="table-actions">
                              <button  class="action-button bt-edit" (click)="updateUser(record.id)" [disabled]="role === 'Member'" [title]="role === 'Member' ? 'You are not authorized to perform this action.': 'Edit'">
                                <span>
                                  <fa-icon [icon]="['fas', 'pen']" class="fa-light" ></fa-icon>
                                </span>
                              </button>
                              <button  class="action-button bt-delete" (click)="openConfirmationDialog(record.id, 'staff')" [disabled]="role === 'Member'" [title]="role === 'Member' ? 'You are not authorized to perform this action.': 'Delete'">
                                <span>
                                  <fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon>
                                </span>
                              </button>
                            </div>
                          </td>
                        </tr>
                    </tbody>
                  </table>
                  <div class="footer">
                    <div class="total-records">Total Records: {{ staffRecordCount }}</div>
                    <div class="pagination-controls">
                      <label for="recordsPerPage">Records per page </label>
                      <select id="recordsPerPage" [(ngModel)]="staffRecordsPerPage" (change)="selectPageSize()" >
                          <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
                      </select>
                      <span>{{ staffCurrentPage }} / {{ staffTotalPages }}</span>
                      <button (click)="previous()" [disabled]="!staffPrePage" class="change-page" title="Previous page">
                        <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
                      </button>
                      <button (click)="next()" [disabled]="!staffNxtPage" class="change-page" title="Next page">
                        <fa-icon [icon]="['fas', 'angle-right']" class="fa-light" style="background-color: none;"></fa-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div *ngIf="activeTab === 'camera'" class="tab-panel">
        <div>
            <!-- <div class="actions">
              <button class="btn-action" (click)="addStaff()" [disabled]="role === 'Member'" [title]="role === 'Member' ? 'You are not authorized to perform this action.': 'Add staff'">
                <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
                Add Staff</button>
            </div> -->
            <div class="container-table">
              <div>
                <div class="tab-head">
                  <div class="search-bar">
                    <app-generic-search
                      [apiUrl]="'cameras/search_suggestion'"
                      [resultsApiUrl]="'cameras/'"
                      [method]="'GET'"
                      [searchParamName]="'q'"
                      [pageSize]="10"
                      [minChars]="2"
                      (resultsFetched)="onCameraResults($event)">
                    </app-generic-search>
                  </div>
                  <button (click)="cameraExportToExcel()" class="export-button">
                    <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
                    EXPORT EXCEL
                  </button>
                </div>
                <div class="responsive-table-wrapper">
                  <table>
                    <thead>
                        <tr>
                        <th>S.No</th>
                        <th>Camera ESN</th>
                        <th>Organization</th>
                        <th>Direction</th>
                        <th>Description</th>
                        <th>Created At</th>
                        <!-- <th>Action Items</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let record of cameraData let i = index ">
                          <td>{{ i + 1 + (cameraCurrentPage - 1) * cameraRecordsPerPage }}</td> 
                          <td>{{ record.camera_esn }}</td>
                          <td>{{ record.organization}}</td>
                          <td>{{ record.direction }}</td>
                          <!-- <td>
                            <div class="text-clip" (click)="openReason(record.description)">
                              {{ record.description }}
                            </div>
                          </td> -->
                          <td>
                            <div>
                              {{ record.description }}
                            </div>
                          </td>
                          <td>{{ record.created_at | date:'dd-MM-yyyy  hh:mm a' }}</td>
                          <!-- <td>
                          
                          <button class="action-button bt-edit"  title="Edit">
                            <span>
                              <fa-icon [icon]="['fas', 'pen']" class="fa-light"></fa-icon>
                            </span>
                          </button>
                          <button class="action-button bt-delete"  title="Delete">
                            <span>
                              <fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon>
                            </span>
                          </button>
                        </td> -->
                        
                        </tr>
                    </tbody>
                  </table>
                  <div class="footer">
                    <div class="total-records">Total Records: {{ cameraRecordCount }}</div>
                    <div class="pagination-controls">
                      <label for="recordsPerPage">Records per page </label>
                      <select id="recordsPerPage" [(ngModel)]="cameraRecordsPerPage" (change)="selectPageSize()" >
                          <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
                      </select>
                      <span>{{ cameraCurrentPage }} / {{ cameraTotalPages }}</span>
                      <button (click)="cameraPrevious()" [disabled]="!cameraPrePage" class="change-page" title="Previous page">
                        <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
                      </button>
                      <button (click)="cameraNext()" [disabled]="!cameraNxtPage" class="change-page" title="Next page">
                        <fa-icon [icon]="['fas', 'angle-right']" class="fa-light" style="background-color: none;"></fa-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div *ngIf="activeTab === 'customer'" class="tab-panel">
        <div>
          <div class="actions">
              <button *ngIf="isPlatformSuperuser" (click)="addCustomer()" class="btn-action">
              <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
              Add Organization</button>
          </div>
          <div class="container-table">
            <div>
              <div class="tab-head">
                <div class="search-bar">
                  <!-- <div>
                    <form  (ngSubmit)="customerSearch()">
                      <input type="text" [(ngModel)]="searchText" name='searchText' id="searchText" placeholder="Search">
                      <button type="submit" style="width: 40px; height: 40px; border-radius: 50%; border: none; background: rgb(37, 139, 229); cursor: pointer;" hidden>
                        <fa-icon [icon]="['fas', 'magnifying-glass']" class="fa-thin" style="color: rgb(228, 235, 237);font-size: 20px;"></fa-icon>
                      </button>
                    </form>
                  </div> -->
                  <app-generic-search
                    [apiUrl]="'organizations/search_suggestion'"
                    [resultsApiUrl]="'organizations/'"
                    [method]="'GET'"
                    [searchParamName]="'q'"
                    [pageSize]="10"
                    [minChars]="2"
                    [extraBody]="{ filter_customers: true }"
                    (resultsFetched)="onCustomerResults($event)">
                  </app-generic-search>
                </div>
                <button (click)="customerExportToExcel()" class="export-button">
                  <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
                  EXPORT EXCEL
                </button>
              </div>
                <div class="responsive-table-wrapper customer-org-table">
                <table>
                  <thead>
                      <tr>
                      <th>S.No</th>
                      <th>Organization Name</th>
                          <th *ngIf="isPlatformSuperuser" class="sortable-header"
                              (click)="toggleCustomerAccountTypeSort()">
                              Account Type
                              <span *ngIf="customerAccountTypeOrdering === 'account_type'">↑</span>
                              <span *ngIf="customerAccountTypeOrdering === '-account_type'">↓</span>
                          </th>
                          <th *ngIf="isPlatformSuperuser">Status</th>
                      <th>Subscription</th>
                      <th>Visitor Mgmt</th>
                      <th>Locality</th>
                      <th>City</th>
                      <th>State</th>
                          <th *ngIf="isPlatformSuperuser" class="sortable-header"
                              (click)="toggleCustomerOnboardingSort()">
                              Onboarding
                              <span *ngIf="customerOnboardingOrdering === 'onboarding'">↑</span>
                              <span *ngIf="customerOnboardingOrdering === '-onboarding'">↓</span>
                          </th>
                      <th>Action Items</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let record of customerArray let i = index ">
                        <td>{{ i + 1 + (cusCurrentPage - 1) * cusRecordsPerPage }}</td>
                        <td>{{ record.name }}</td>
                          <td *ngIf="isPlatformSuperuser" class="account-type-column">
                          <span class="account-type-pill"
                                [class.customer]="!record.is_demo_account"
                                [class.demo]="record.is_demo_account">
                            {{ record.is_demo_account ? 'Demo' : 'Customer' }}
                          </span>
                          </td>
                          <td *ngIf="isPlatformSuperuser">
                              <div class="subscription-toggle">
                                  <label class="toggle-switch"
                                         [title]="record.is_active ? 'Disable organization' : 'Enable organization'">
                                      <input
                                              type="checkbox"
                                              [checked]="record.is_active"
                                              [disabled]="record.status_loading"
                                              (change)="toggleOrganizationStatus(record, $event)"/>
                                      <span class="toggle-slider"></span>
                                  </label>
                                  <span class="status-pill" [class.active]="record.is_active"
                                        [class.inactive]="!record.is_active">
                              {{ record.is_active ? 'Active' : 'Disabled' }}
                            </span>
                              </div>
                          </td>
                        <td>
                          <div class="subscription-toggle">
                            <label class="toggle-switch" [title]="record.subscription_enabled ? 'Disable subscription' : 'Enable subscription'">
                              <input
                                type="checkbox"
                                [checked]="record.subscription_enabled"
                                [disabled]="record.subscription_loading"
                                (change)="toggleSubscription(record, $event)" />
                              <span class="toggle-slider"></span>
                            </label>
                            <span class="status-pill" [class.active]="record.subscription_enabled" [class.inactive]="!record.subscription_enabled">
                              {{ record.subscription_enabled ? 'Enabled' : 'Disabled' }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div class="subscription-toggle">
                            <label class="toggle-switch" [title]="record.visitor_management_enabled ? 'Disable visitor management' : 'Enable visitor management'">
                              <input
                                type="checkbox"
                                [checked]="record.visitor_management_enabled"
                                [disabled]="record.visitor_management_loading"
                                (change)="toggleVisitorManagement(record, $event)" />
                              <span class="toggle-slider"></span>
                            </label>
                            <span class="status-pill" [class.active]="record.visitor_management_enabled" [class.inactive]="!record.visitor_management_enabled">
                              {{ record.visitor_management_enabled ? 'Enabled' : 'Disabled' }}
                            </span>
                          </div>
                        </td>
                        <td>{{ record.address.locality }}</td>
                        <td>{{ record.address.city }}</td>
                        <td>{{record.address.state}}</td>
                          <td *ngIf="isPlatformSuperuser" class="onboarding-column">
                              {{ formatOnboardingListLabel(record.onboarding_summary) }}
                          </td>
                        <td class="table-actions-cell">
                          <div class="table-actions">
                            <button  class="action-button bt-camera"
                            [disabled]="role === 'Member'"
                            [title]="role === 'Member' ? 'You are not authorized to perform this action.': 'Camera'"
                            (mouseenter)="hoveredRowId=record.id" (mouseleave)="hoveredRowId=null"
                            (click)="viewCamera(record.id, record.name)"
                            >
                              <span>
                                <fa-icon [icon]="['fas', 'video']" class="fa-light"></fa-icon>
                              </span>
                            </button>
                              <button *ngIf="isPlatformSuperuser" class="action-button bt-bridge"
                                      title="Bridges"
                                      (mouseenter)="hoveredRowId=record.id" (mouseleave)="hoveredRowId=null"
                                      (click)="viewBridge(record.id, record.name)"
                              >
                              <span>
                                <fa-icon [icon]="['fas', 'hdd']" class="fa-light"></fa-icon>
                              </span>
                              </button>
                            <button  class="action-button bt-edit" (click)="updateCustomer(record.id)" title="Edit">
                              <span>
                                <fa-icon [icon]="['fas', 'pen']" class="fa-light" ></fa-icon>
                              </span>
                            </button>
                            <button  class="action-button bt-delete" (click)="openConfirmationDialog(record.id, 'customer')" title="Delete">
                              <span>
                                <fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon>
                              </span>
                            </button>
                          </div>
                        </td>
                      </tr>
                  </tbody>
                </table>
                <div class="footer">
                  <div class="total-records">Total Records: {{ cusRecordCount }}</div>
                  <div class="pagination-controls">
                    <label for="recordsPerPage">Records per page </label>
                    <select id="recordsPerPage" [(ngModel)]="cusRecordsPerPage" (change)="selectPageSize()" >
                        <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
                    </select>
                    <span>{{ cusCurrentPage }} / {{ cusTotalPages }}</span>
                    <button (click)="previous()" [disabled]="!staffPrePage" class="change-page" title="Previous page">
                      <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
                    </button>
                    <button (click)="next()" [disabled]="!staffNxtPage" class="change-page" title="Next page">
                      <fa-icon [icon]="['fas', 'angle-right']" class="fa-light" style="background-color: none;"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      </div>
    </div>
  </div>

  <!-- Confirmation dialog -->
  <!-- <div *ngIf="showConfirmationDialog" class="confirmation-modal">
    <div class="modal-content">
      <h2>Are yor sure you want to delete this user permanently?</h2>

      <div class="options">
        <button type="button" class="btn-cancel" >CANCEL</button>
        <button type="submit" class="btn-confirm" >DELETE</button>
        
      </div>
    </div>
  </div> -->

  <div *ngIf="showConfirmationDialog" class="confirmation-modal">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" stroke="#6A5ACD" stroke-width="2" fill="none"/>
        <path d="M9 12l2 2 4-4" stroke="#FFFFFF" stroke-width="2"/>
        </svg> -->
        <i class="bi bi-exclamation-triangle warning-icon"></i>
        <h3>Are You Sure?</h3>
      </div>
      <div class="modal-body">
        <p>Do you want to delete this {{activeTab}}? Confirm your choice below!</p>
      </div>
      <div class="modal-footer">
        <button (click)="confirmDelete()" class="confirm-btn modal-red">Yes, Proceed</button>
        <button (click)="closeConfirmationDialog()" class="cancel-btn cancel-btn-green">Cancel</button>
      </div>
  </div>
  </div>

<div *ngIf="showStaffStatusDialog" class="confirmation-modal">
    <div class="modal-content">
        <div class="modal-header">
            <i class="bi bi-exclamation-triangle warning-icon"></i>
            <h3>{{ staffStatusNextValue ? 'Enable Staff Account?' : 'Disable Staff Account?' }}</h3>
        </div>
        <div class="modal-body">
            <p *ngIf="staffStatusNextValue">The user will be able to login again.</p>
            <p *ngIf="!staffStatusNextValue">The user will no longer be able to login.</p>
        </div>
        <div class="modal-footer">
            <button (click)="confirmStaffStatusChange()" class="confirm-btn modal-red" [disabled]="staffStatusLoading">
                {{ staffStatusNextValue ? 'Enable' : 'Disable' }}
            </button>
            <button (click)="closeStaffStatusDialog()" class="cancel-btn cancel-btn-green"
                    [disabled]="staffStatusLoading">Cancel
            </button>
        </div>
    </div>
</div>

<app-add-demo-account-dialog
        [visible]="showDemoAccountDialog"
        (closed)="closeDemoAccountDialog()"
        (created)="onDemoAccountCreated()">
</app-add-demo-account-dialog>
